<script>
import dayjs from 'dayjs';

export default {
  data() {
    return {
      staticDays: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
      selectedMonth: null,
      monthlyEvents: [],
      weeks: [],
      days: [],
      events: [],
      currentYear: null,
      loading: true
    };
  },
  watch: {
    selectedMonth: {
      handler(n) {
        this.reloadMonthlyEvents();
      }
    },
    events: {
      handler(n) {
        this.reloadMonthlyEvents();
      }
    }
  },
  methods: {
    hasEvent(day) {
      return this.events.find(x => x.date === day.formatted);
    },
    reloadMonthlyEvents() {
      this.monthlyEvents = [];
      // iterate over the weeks
      for (let i = 0; i < this.days.length; ++i) {
        let day = this.days[i];
        let fmt = 'YYYY-MM-DD';
        let ev = this.events.find(
          x => dayjs(x.date).format(fmt) === dayjs(day.formatted).format(fmt)
        );
        // push to the array if the event is found
        if (ev) {
          let d = dayjs(ev.date);
          this.monthlyEvents.push({
            id: ev.id,
            date: d.format('DD MMM'),
            day: d.format('DD'),
            month: d.format('MMM'),
            name: ev.name
          });
        }
      }
    },
    dayjs(v) {
      return dayjs(v);
    },
    setNextMonth() {
      this.current = this.current.add(1, 'month');
      this.refresh();
    },
    setPrevMonth() {
      this.current = this.current.subtract(1, 'month');
      this.refresh();
    },
    refresh() {
      this.selectedMonth = this.current.format('MMMM');
      this.currentYear = this.current.format('YYYY');
      // render the month
      this.setMonth();
    },
    backFill() {
      let clone = this.current.clone();
      let dayOfWeek = clone.day();
      if (!dayOfWeek) {
        return;
      }
      clone = clone.subtract(dayOfWeek + 1, 'day');
      for (let i = dayOfWeek; i > 0; --i) {
        clone = clone.add(1, 'day');
        this.setDay(clone);
      }
    },
    forwardFill() {
      let clone = this.current
        .clone()
        .add(1, 'month')
        .subtract(1, 'day');
      let dayOfWeek = clone.day();
      if (dayOfWeek === 6) {
        return;
      }
      for (let i = dayOfWeek; i < 6; ++i) {
        clone = clone.add(1, 'day');
        this.setDay(clone);
      }
    },
    getWeek(day) {
      if (day.day() === 0) {
        this.weeks.push([]);
      }
      return this.weeks[this.weeks.length - 1];
    },
    setDay(day) {
      let curWeek = this.getWeek(day);
      let d = {};
      d.num = day.format('D');
      d.day = day.format('DD-MM-YYYY');
      d.formatted = day.format('YYYY-MM-DD');
      d.isSelected = false;
      d.state = 'day';
      let dayOfWeek = day.day();
      // checks if the current day is today
      if (this.today.isSame(day, 'day')) {
        d.state += ' today';
        d.isToday = true;
      } else if (
        // gray out Sunday, Saturday, or the days that are not within the current selected month
        day.month() !== this.current.month() ||
        dayOfWeek === 0 ||
        dayOfWeek === 6
      ) {
        d.state += ' other';
      }
      curWeek.push(d);
      this.days.push(d);
    },
    setMonth: function() {
      this.days = [];
      this.weeks = [];
      // back fill
      this.backFill();
      // fill with days
      let clone = this.current.clone();
      while (clone.month() === this.current.month()) {
        this.setDay(clone);
        clone = clone.add(1, 'day');
      }
      // forward fill
      this.forwardFill();
    }
  },
  mounted() {
    this.today = dayjs();
    this.current = dayjs().date(1);
    // refresh on mounted
    this.refresh();
  }
};
</script>
